import { openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1619c258")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: `mouse-selection quadrant-${$props.quadrant}`,
    style: {
      top: $props.top + 'px',
      left: $props.left + 'px',
      width: $props.width + 'px',
      height: $props.height + 'px',
    }
  }, null, 6))
})